<ng-container *ngIf="readonly">
  <app-view-item
    text="{{ value | date: displayFormat }}"
    [borderless]="borderless"
  ></app-view-item>
  <!-- <span *ngIf="!value">&nbsp;</span> -->
</ng-container>

<nz-date-picker
  *ngIf="!readonly"
  [(ngModel)]="date"
  [nzShowTime]="showTime"
  (ngModelChange)="onModelChange($event)"
  [nzAllowClear]="nzAllowClear"
  [nzFormat]="displayFormat"
  [nzInputReadOnly]="disabled"
  [nzDisabled]="nzDisabled"
  [nzPlaceHolder]="placeHolder"
  (nzOnOk)="onOk($event)"
  [class.bg-grey-lighter]="readonly && !borderless"
  class="width-100"
>
</nz-date-picker>
